<template>
    <div class="td-autocomplete form-item">
        <div v-if="!hideLabel">
            <label for="location" class="td-text-bold">TimeZone: </label>
        </div>
        <div :class="[searchTermTimeZone ? 'focused': '', 'autocomplete-input']">
            <input type="text"
                   placeholder="Select TimeZone from the list"
                   name="timeZone"
                   id="timeZone"
                   @focus="showTimeZoneList = true"
                   v-model="searchTermTimeZone"
                   @keyup.enter="selectTimeZone(timeZoneList[0])"
                   :class="{ error: isError}" />
        </div>
        <div></div>
        <div :class="[showTimeZoneList ? 'show-results' : 'hide-results', 'autocomplete-results']">
            <ul class="results-list" v-if="timeZoneList.length > 0">
                <li v-for="(item, idx) in timeZoneList" :key="idx">
                    <a @click.prevent="selectTimeZone(item)" href="#">{{item.display}}</a>
                </li>
            </ul>
            <ul class="results-list" v-else>
                <li class="td-text-subdued pa-1">
                    No TimeZones Found
                </li>
            </ul>
            <icon @click="showTimeZoneList = false" name="faXmark" type="solid" class="td-text-danger close-list"></icon>
        </div>
    </div>
</template>

<script>
    import script from './TimeZoneLookup';
    export default script;
</script>

<style lang="less">
    @import './TimeZoneLookup.less';
</style>